import a from "../css/img/kaseya-logo-login.svg.js";
var e = {
  URL: "http://www.kaseya.com",
  COPYRIGHT: "\xa9 Kaseya 2021",
  LOGO: a,
  ONEURL: "https://one.kaseya.com",
  SSO_LEARN_MORE_URL: "https://helpdesk.kaseya.com/hc/en-gb/articles/360020946058-KaseyaOne-Overview"
};
export { e as KASEYA };